import dailyColors from '../constants/dailyColors';

export const getDisplaydate = (dateProp, locale) => {
  const date = new Date(+dateProp);
  const day = date.getDay();
  return {
    colors: dailyColors[day],
    message: locale.approved.daily_messages[day],
    dayOfWeek: locale.days_of_week[day].toUpperCase(),
    date: date.getDate(),
    month: locale.months[date.getMonth()].toUpperCase(),
    time: date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    })
  };
};
